$(document).ready(function(){

  // project tag PDP
  let projectTagInput = document.querySelector("[data-project-tag-input]") || null;
  let projectTagCounter = document.querySelector("[data-protag-text-counter]") || null;
  let mainForm = $("form.product-single__form");
  if(projectTagInput){
    projectTagInput.addEventListener("keyup",(event) => {
      let _this = event.target;
      let len = _this.value.length;
      if(projectTagCounter){
        projectTagCounter.innerHTML = len + "/"+(_this.getAttribute('maxlength') || 20);
      }
      if(mainForm.length && _this.value.length){
        mainForm.find('[data-project-tag-property]').attr("value", _this.value);
      }
      else{
        mainForm.find('[data-project-tag-property]').attr("value", "");
      }
    });
  }
  // project tag PDP &&

  /* remove cookie sales agent */
  $(document).on('click','.exit-user',function(event){
    event.preventDefault();
    localStorage.removeItem('sparkLayerData');
    window.location = '/account';
  });
  /* remove cookie sales agent END */

  $(document).on('click','.main-account-div .load-more',function(){
    $(this).addClass('hide');
    $(this).closest('.grid__item').find('table tr.hide').removeClass('hide');
  });


  
  
  /* Shipping delivery widget */
  
  $(document).on('change','.shipping-delivery-widget .receive-order-checkbox input[type=radio]',function(e){
    $(".shipping-delivery-widget .receive-order-dropdown").removeClass("active");
    $(this).closest('.receive-order-raw').find('.receive-order-col').removeClass("active");
    $(this).closest('.receive-order-col').addClass("active");
  });

  $(document).on('click','.shipping-delivery-widget .receive-order-dropdown .dropdown-active',function(e){
    $(this).closest('[data-address-block]').find(".receive-order-dropdown").toggleClass("active");
  });


  $(document).on('click','.shipping-delivery-widget [data-address-block] .dropdown-adrs-li',function(e){
    e.preventDefault();
    var getCurrentValue = $(this).attr('data-value');
    $(this).closest('[data-address-block]').find("[data-selected-address-value]").attr('data-selected-address-value',getCurrentValue).text(getCurrentValue);
    $(this).closest('.receive-order-dropdown').removeClass("active");
    $(this).closest('[data-address-block]').find("[data-confirm-address-btn]").removeClass("hide");
    $(this).closest('[data-address-block]').find(".shipping-note-confirmed").addClass("hide");
  });


  //confirm-address-btn click event
  // $(document).on('click','.shipping-delivery-widget [data-address-block] [data-confirm-address-btn]',function(e){
  //   e.preventDefault();
  //   var _this = $(this);
  //   $(this).addClass('validating');
  //   $(this).text('Validating shipping address...');
  //   setTimeout(function(){
  //       _this.addClass('hide');
  //       _this.removeClass('validating');
  //       _this.text('Confirm Address');
  //       _this.closest('[data-address-block]').find(".shipping-note-confirmed").removeClass("hide");
  //   },1200);
  // });
  //confirm-address-btn click event

  

  
  // new address add popup

  $(document).on('click','.adrs-popup-main .dropdown-active',function(e){
    e.preventDefault();
    // $('.adrs-popup-main .select-dropdown').removeClass("active");
    $(this).closest('.select-dropdown').toggleClass("active");
  });

  
  $(document).on('click','.shipping-delivery-widget .dropdown-newadrs-li [data-add-address]',function(e){
    e.preventDefault();

    $('#CartDrawer .js-drawer-close').trigger('click');
    
    $('body').addClass("adrs-popup-open");
    $(".shipping-delivery-widget .receive-order-dropdown").removeClass("active");
    
  });
  
  $(document).on('click','.adrs-popup-main [data-popup-close]',function(e){
    e.preventDefault();
    $('body').removeClass("adrs-popup-open");

    setTimeout(function(){
      $('header .js-drawer-open-cart')[0].click();
    },90);
    
  });
  // new address add popup

  $('body').on('click', '.receive-order-dropdown.shipping-locations .dropdown-adrs-ul .dropdown-adrs-li', function(){
    // console.log("I am clicked ....", $(this).data('address'));
    if($(this).data('address') != null){
      $('.receive-order-dropdown.shipping-locations .dropdown-active').addClass('active');
      $('.receive-order-dropdown.shipping-locations .dropdown-active').data('address', $(this).data('address'));
      $('.receive-order-dropdown.shipping-locations .dropdown-active span.address').html($(this).data('name'));

      $(this).parents('.receive-order-dropdown').removeClass('active');
      $(".shipping-error").addClass("hide");
    }    
  });

  $('.btn.addr-confirm').click(function(){    
    let address = $('.receive-order-dropdown.shipping-locations .dropdown-active').data('address');
    if(address != null){
      $('#cart_address').val(JSON.stringify(address));
      $customerParams.address = (address.address1 + ' ' + address.address2).trim();
      $customerParams.city = address.city;
      $customerParams.postalCode = address.zip;
      $customerParams.state = address.province;
      $customerParams.country = address.country_code;
      $customerParams.isPickUp = "1";

      if(address.phone == "" || address.phone == undefined || address.phone == null || 
        address.company == "" || address.company == undefined || address.company == null){
        $(".shipping-error").removeClass("hide");
      }else{
        getCartBasedShippingRates($(this), true);
      }      
    }    
  });

  $("body").on("click", '.receive-order-dropdown.pickup-locations .dropdown-adrs-ul .dropdown-adrs-li', function(){
    if($(this).data('address') != null){
      $('.receive-order-dropdown.pickup-locations .dropdown-active').addClass('active');
      $('.receive-order-dropdown.pickup-locations .dropdown-active').data('address', $(this).data('address'));
      $('.receive-order-dropdown.pickup-locations .dropdown-active span.address').html($(this).data('name'));

      let address = $('.receive-order-dropdown.pickup-locations .dropdown-active').data('address');
      $('#cart_address').val(JSON.stringify(address));

      $customerParams.address = (address.address1 + ' ' + address.address2).trim();
      $customerParams.city = address.city;
      $customerParams.postalCode = address.zip;
      $customerParams.state = address.province;
      $customerParams.country = address.country_code;
      $customerParams.isPickUp = "2";

      localStorage.setItem('pickUpLocation', address.name);

      getCartBasedShippingRates($(this), false);

      $(this).parents('.receive-order-dropdown').removeClass('active');          
      localStorage.setItem('shipRate', "1");            
    }    
  });
  
  $('.select-dropdown .countries-dropdown li').click(function(){    
    var countryInput = document.querySelector('#country')
    countryInput.value = $(this).data("iso");
    countryInput.dispatchEvent(new Event('input', { bubbles: true }));

    let parent = $(this).parents('.select-dropdown');
    parent.find("span").html($(this).data("name"));
    parent.toggleClass("active");    
    
    $("#country").data("country", $(this).data("name"));
    $(".input-reset").val('');
  });

  function renderCachedAddresses(address){
    let addresses = localStorage.getItem("newaddresses");
    if(addresses == null){
      addresses = {};
    }else{
      addresses = JSON.parse(addresses);
    }

    //clear existing addresses
    const oldAddresses = document.querySelectorAll(".shipping-delivery-widget .shipping-locations .dropdown-adrs-ul li.new-address");
    oldAddresses.forEach(function(item){
      item.remove();
    });
    
    if(address != null){
      const _uid = CryptoJS.MD5(address.address1 + address.address2 + address.city + address.company + address.country + 
        address.country_code + address.first_name + address.last_name + address.phone + address.phone +
        address.province + address.zip).toString();
  
      addresses[_uid] = address;
      // console.log(addresses);
      localStorage.setItem("newaddresses", JSON.stringify(addresses));
    }    

    //render cached addresses
    const keys = Object.keys(addresses);
    if(keys.length > 0){
      let addressElm = document.querySelector(".shipping-delivery-widget .shipping-locations .dropdown-adrs-ul");
      keys.forEach(function (uid) { 
        let elm = dropdownAddNewOption(addresses[uid]);
        addressElm.append(elm);
      });
    }    
  }

  function dropdownAddNewOption(address){
    let elm = document.createElement('li');
    elm.classList.add("dropdown-adrs-li");
    elm.classList.add("new-address");    
    elm.setAttribute("data-address", JSON.stringify(address));

    let shortAddress = [];
    shortAddress.push(address.address1);
    shortAddress.push(address.address2);
    shortAddress.push(',');
    shortAddress.push(address.province);
    shortAddress.push(address.zip);
    shortAddress.push(address.country);
    shortAddress = shortAddress.join(' ');
    shortAddress = shortAddress.replaceAll(" ,", ",");
    elm.setAttribute("data-value", shortAddress);

    elm.innerHTML = '<div class="dropdown-adrs"><p>'+shortAddress+'</p><p class="dropdown-adrs-span">'+address.company+'</p></div>';

    return elm;
  }

  let debounce;
  $('.dropdown-search #addressSearch').keyup(function(){
    clearTimeout(debounce);
    debounce = setTimeout(() => {
      let query = $(this).val();    
      let pattern = [];
      pattern.push("^");
      query.split(" ").forEach(function(word){
        pattern.push("(?=.*"+word+")");
      });
      pattern.push(".*$");
      pattern = pattern.join("");

      const addresses = document.querySelectorAll(".shipping-delivery-widget .shipping-locations .dropdown-adrs-ul li");
      addresses.forEach(function(item){
        item.classList.remove("hide");
        if(item.innerText.trim().replaceAll("\n", " ").search(new RegExp(pattern, "im")) == -1){
          item.classList.add("hide");
        }
      });
    }, 250);    
  });

  $('.btn.add-new-btn').click(function(e){
    e.preventDefault();

    let parentContainer = $('.adrs-popup-main.s-loopup-address');
    let address = {
      address1: parentContainer.find('#address1').val(),
      address2: parentContainer.find('#address2').val(),
      city: parentContainer.find('#city').val(),
      company: parentContainer.find('#company').val(),
      country: parentContainer.find('#country').data('country'),
      country_code: parentContainer.find('#country').data('country') == "Canada" ? "CA" : "US",
      first_name: parentContainer.find('#first_name').val(),
      last_name: parentContainer.find('#last_name').val(),
      phone: parentContainer.find('#phone').val(),
      province: parentContainer.find('#state').val(),
      zip: parentContainer.find('#postal_code').val()
    }

    renderCachedAddresses(address);    

    let shortAddress = [];
    shortAddress.push(address.address1);
    shortAddress.push(address.address2);
    shortAddress.push(',');
    shortAddress.push(address.province);
    shortAddress.push(address.zip);
    shortAddress.push(address.country);
    shortAddress = shortAddress.join(' ');
    shortAddress = shortAddress.replace(" ,", ",");

    var status = validateAddress(address);
    if(status){
      $('.receive-order-dropdown.shipping-locations .dropdown-active').addClass('active');
      $('.receive-order-dropdown.shipping-locations .dropdown-active').data('address', address);
      $('.receive-order-dropdown.shipping-locations .dropdown-active span.address').html(shortAddress);

      $('[data-address-block] [data-confirm-address-btn]').removeClass("hide");
      $('[data-address-block] .shipping-note-confirmed').addClass("hide");
      
      $('body').removeClass("adrs-popup-open");

      setTimeout(function(){
        $('header .js-drawer-open-cart')[0].click();
      },90);    
    }    
    
  });

  function validateAddress(address){
    let parentContainer = $('.adrs-popup-main.s-loopup-address .adrs-popup-form');
    let errorHTML = '<div class="error-text"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none"><path d="M7.00004 9.83333C6.67787 9.83333 6.41671 10.0945 6.41671 10.4167C6.41671 10.7388 6.67787 11 7.00004 11C7.32221 11 7.58337 10.7388 7.58337 10.4167C7.58337 10.0945 7.32221 9.83333 7.00004 9.83333Z" fill="currentcolor"></path><path d="M6.56252 8.66675C6.56252 8.90837 6.7584 9.10425 7.00002 9.10425C7.24164 9.10425 7.43752 8.90837 7.43752 8.66675H6.56252ZM7.43752 4.58342C7.43752 4.34179 7.24164 4.14592 7.00002 4.14592C6.7584 4.14592 6.56252 4.34179 6.56252 4.58342H7.43752ZM12.3959 7.50008C12.3959 10.4801 9.98004 12.8959 7.00002 12.8959V13.7709C10.4633 13.7709 13.2709 10.9634 13.2709 7.50008H12.3959ZM7.00002 12.8959C4.01999 12.8959 1.60419 10.4801 1.60419 7.50008H0.729187C0.729187 10.9634 3.53674 13.7709 7.00002 13.7709V12.8959ZM1.60419 7.50008C1.60419 4.52005 4.01999 2.10425 7.00002 2.10425V1.22925C3.53674 1.22925 0.729187 4.0368 0.729187 7.50008H1.60419ZM7.00002 2.10425C9.98004 2.10425 12.3959 4.52005 12.3959 7.50008H13.2709C13.2709 4.0368 10.4633 1.22925 7.00002 1.22925V2.10425ZM7.43752 8.66675V4.58342H6.56252V8.66675H7.43752Z" fill="currentcolor"></path></svg>ERROR_MESSAGE</div>';
    var allOk = true;

    parentContainer.find(".error-text").remove();
    parentContainer.find(".input-grp.error-grp").removeClass('error-grp');

    allOk = allOk && isRequired('company', address.company, errorHTML);
    allOk = allOk && isRequired('address1', address.address1, errorHTML);
    allOk = allOk && isRequired('postal_code', address.zip, errorHTML);
    allOk = allOk && isRequired('phone', address.phone, errorHTML);
    allOk = allOk && isPhoneNumber('phone', address.phone, errorHTML);    

    return allOk;
  }

  function isRequired(field, val, errorHTML){
    let parentContainer = $('.adrs-popup-main.s-loopup-address .adrs-popup-form');
    if(val == "" || val == null){
      var parent = parentContainer.find('#' + field).parent();
      parent.append(errorHTML.replace("ERROR_MESSAGE", "This field is required"));
      parent.addClass("error-grp");
      return false;
    }

    return true;
  }

  function isPhoneNumber(field, val, errorHTML){
    let parentContainer = $('.adrs-popup-main.s-loopup-address .adrs-popup-form');
    if(/^(\+?1 ?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(val) == false){
      var parent = parentContainer.find('#'+field).parent();
      parent.append(errorHTML.replace("ERROR_MESSAGE", "Please enter valid Phone number"));
      parent.addClass("error-grp");
      return false;
    }

    return true;
  }

  // function getCart(){
  //   fetch(window.Shopify.routes.root + 'cart.js', {
  //     method: 'GET',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     }
  //   })
  //   .then(response => {
  //     return response.json();
  //   }).then(data => { 
  //     let properties = data.items[0].properties;
  //     properties["_uid"] = $customerParams.uID;
  //     let payload = {
  //       "line": 1,
  //       "properties": properties
  //     };

  //     console.log(payload);

  //     updateCartAttribute(payload);
  //   });
  // }

  async function updateCartAttributes(data){
    let properties = null;
    let indx = 0;
    let payload = {};
    let count = data.items.length;
    for(var i=0;i<data.items.length; i++){
      indx = i + 1;
      properties = data.items[i].properties;
      properties["_uid"] = $customerParams.uID;
      properties["_count"] = count;
      payload = {
        "line": indx,
        "properties": properties
      };
      // console.log("Updating ..... ", indx);
      await updateCartAttribute(payload);
    }
  }

  function getCart(){
    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      return response.json();
    }).then(data => { 
      updateCartAttributes(data);
    });
  }

  function getCartBasedShippingRates(elm, isShipping){    
    $customerParams.uID = $customerParams.customerId.toString() + "_" + Date.now().toString();        
    $customerParams.store = "ennisfabrics";

    let ennisRateCache = {
      "_uid": $customerParams.uID,
      "rate": ""
    }
    localStorage.setItem("ennisRate", JSON.stringify(ennisRateCache));

    getCart();

    let baseURL = 'https://ennis-shipping-app-c87287729dda.herokuapp.com';

    if(isShipping){
      var _this = $(elm);
      _this.addClass('validating');
      _this.text('Validating shipping address...');
    }    

    let url = baseURL;
    fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify($customerParams)
    })
    .then(response => response.json())
    .then(function(response) {      
    });
    
    if(isShipping){
      setTimeout(function(){
        _this.addClass('hide');
        _this.removeClass('validating');
        _this.text('Confirm Address');
        _this.closest('[data-address-block]').find(".shipping-note-confirmed").removeClass("hide");
        localStorage.setItem('shipRate', "1");
      }, 10 * 1000);
    }    
    //localStorage.setItem('shipRate', "1");
  }

  async function updateCartAttribute(payload){
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      return response.json();
    })
  }

  setTimeout(function(){
    renderCachedAddresses(null);
  }, 7 * 1000);

  /* Shipping delivery widget END */

  


});